import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  button: {
    padding: '0'
  },
  loading: {
    width: '100%',
    height: '100%',
    display: 'content',
    marginTop: '0px'
  },
  paper: {
    '& > div': {
      maxHeight: 'none'
    }
  },
  tableWrapper: {
    maxHeight: 'calc(100vh - 250px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  tableCellWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  pagination: {
    '& > .MuiPagination-ul': {
      justifyContent: 'flex-end',
      marginBlock: '.5em'
    }
  },
  manageButton: {
    '.MuiButton-textPrimary': {
      root: {
        minWidth: '58px'
      },
      label: {
        paddingRight: 0
      }
    }
  }
});
